// extracted by mini-css-extract-plugin
export default {"label":"topMenu-module__label__g6L1X"};